import React, { useCallback } from 'react';

import { Button } from 'primereact/button';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { logoutAsync } from '../state/auth/authSlice';
import { AppDispatch } from '../state/store';

interface Params {
  onReturn: () => void;
  onLogout: () => void;
}
const LogoutCard: React.FC<Params> = ({ onReturn, onLogout }) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const logoutCallback = useCallback(async () => {
    await dispatch(logoutAsync());
    onLogout();
    navigate('/login');
  }, [dispatch, navigate, onLogout]);

  return (
    <div className="detailed-info-card default-card__buttons flex align-items-center justify-content-start gap-3">
      <Button
        className="p-button-danger justify-content-center w-7rem"
        onClick={() => logoutCallback()}
      >
        Да
      </Button>
      <Button
        className="p-button-secondary justify-content-center w-7rem"
        onClick={() => onReturn()}
      >
        Отмена
      </Button>
    </div>
  );
};

LogoutCard.displayName = 'LogoutCard';

export default LogoutCard;
